/* unplugin-vue-components disabled */import script from "./AssetAllocation.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetAllocation.vue?vue&type=script&setup=true&lang=js"

import "./AssetAllocation.vue?vue&type=style&index=0&id=d148b47e&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d148b47e"]])

export default __exports__